import { customAxios } from "./customAxios";

/**
 * 유지보수항목/성능점검항목 목록(파라미터)
 * @param {*} query 
 * @returns 
 */
export const getMaintenanceCheckupItemsByQuery = async(query)=>{
  const res = await customAxios.get('/api/maintenanceCheckupItems', {params : query});
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수항목/성능점검항목 상세
 * @param {*} id 
 * @returns 
 */
export const getMaintenanceCheckupItemsById = async(id)=>{
  const res = await customAxios.get('/api/maintenanceCheckupItems/'+id);
  //console.log(res);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 유지보수항목/성능점검항목 삭제
 * @param {*} param 
 */
export const deleteMaintenanceCheckupItems = async(param)=>{
  //console.log(param);
  await customAxios.delete('/api/maintenanceCheckupItems/'+param);
}
